import { UserInfo } from "../providers/SessionProvider";
import { WizardAPI } from "../config/_axios_config";

export const AuthService = {
  current: (): Promise<UserInfo> => {
    return WizardAPI.get("v4/user/current").then((response) => response.data);
  },

  signout: (): Promise<void> => {
    // CSRF token is injected automatically by the WizardAPI request interceptor.
    return WizardAPI.post("v4/auth/okta/logout", {}).then(() => {});
  },

  token: (params: {
    jiraApiToken?: string;
    githubApiToken?: string;
  }): Promise<UserInfo> => {
    return WizardAPI.post("v4/user/token", params).then(
      (response) => response.data
    );
  },
};
